import React from 'react';
import PropTypes from 'prop-types';

function CalloutComponent({
  dClass = 'callout',
  selectComponent = function selectComponent() {
    return null;
  },
  pClass = '',
  paraText = '',
}) {
  return (
    <div className={dClass} onClick={selectComponent}>
      <p className={pClass}>{paraText}</p>
    </div>
  );
}

CalloutComponent.propTypes = {
  dClass: PropTypes.string,
  selectComponent: PropTypes.func,
  pclass: PropTypes.string,
  paraText: PropTypes.string,
};

export { CalloutComponent };
